export const knob = {
  preserveData: Symbol('preserveData'),
  circular: Symbol('circular')
};
